import { useEffect, useRef } from 'react';

export function useOutsideClickHandler<T extends HTMLElement = HTMLElement>(
    callback: () => void,
    excludeRefs: React.RefObject<HTMLElement | null>[] = []
): React.RefObject<T | null> {
    const ref = useRef<T | null>(null);

    useEffect(() => {
        const handleClick = (event: MouseEvent) => {
            const target = event.target as Node;

            const isExcluded = excludeRefs.some((r) => r.current?.contains(target));
            if (ref.current && !ref.current.contains(target) && !isExcluded) {
                callback();
            }
        };
        document.addEventListener('mousedown', handleClick, true);

        return () => document.removeEventListener('mousedown', handleClick, true);
    }, [callback, excludeRefs]);

    return ref;
}
export default useOutsideClickHandler;
